import {
  differenceInYears,
  differenceInMonths,
  differenceInWeeks,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  addYears,
  addMonths,
  addWeeks,
  addDays,
  addHours,
  addMinutes,
  addSeconds,
  isBefore
} from 'date-fns';

import { replaceTextWithValues } from 'src/common/utils/text-replace';
import arrayToSentence from 'src/common/utils/array-to-sentence';

const diffFns = {
  year: differenceInYears,
  month: differenceInMonths,
  week: differenceInWeeks,
  day: differenceInDays,
  hour: differenceInHours,
  minute: differenceInMinutes,
  second: differenceInSeconds
};

const addFns = {
  year: addYears,
  month: addMonths,
  week: addWeeks,
  day: addDays,
  hour: addHours,
  minute: addMinutes,
  second: addSeconds
};

const tickIntervals = {
  year: 31536000,
  month: 2618784,
  week: 604800,
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1
};

const maxCountdownOptions = 3;

const defaultTimeStrings = {
  year: '%{val} year',
  years: '%{val} years',
  month: '%{val} month',
  months: '%{val} months',
  week: '%{val} week',
  weeks: '%{val} weeks',
  day: '%{val} day',
  days: '%{val} days',
  hour: '%{val} hour',
  hours: '%{val} hours',
  minute: '%{val} minute',
  minutes: '%{val} minutes',
  second: '%{val} second',
  seconds: '%{val} seconds'
};

export const getHumanCountdown = (
  date,
  timeStrings,
  { dateNow = new Date(), conjunction } = {}
) => {
  let dateX = dateNow;
  let dateY = new Date(date);
  let humanCountdownParts = [];
  let finalDiffKey = '';
  let finalDiff = 0;
  const diffKeys = Object.keys(diffFns);

  // Return 0 seconds if in past
  if (isBefore(dateY, dateX)) {
    return {
      humanCountdown: replaceTextWithValues(
        timeStrings.seconds || defaultTimeStrings.seconds,
        {
          val: 0
        }
      ),
      remainderInSeconds: 0
    };
  }

  const maxCountdownOptionsLocal = Math.min(
    maxCountdownOptions,
    diffKeys.length - 1
  );

  let counter = 0;

  for (let i = 0; i < diffKeys.length; i++) {
    const diffKey = diffKeys[i];
    const diffFn = diffFns[diffKey];
    const addFn = addFns[diffKey];

    const diff = diffFn(dateY, dateX);
    const replacementValue = { val: diff };
    let diffHuman = '';

    if (diff || counter > 0) {
      let timeString = timeStrings[diffKey] || defaultTimeStrings[diffKey];

      if (diff > 1 || diff === 0) {
        timeString =
          timeStrings[`${diffKey}s`] || defaultTimeStrings[`${diffKey}s`];
      }

      diffHuman = replaceTextWithValues(timeString, replacementValue);

      humanCountdownParts.push(diffHuman);

      counter += 1;

      if (counter === maxCountdownOptionsLocal) {
        finalDiffKey = diffKey;
        finalDiff = diff;
        break;
      }
    }

    dateX = addFn(dateX, diff);
    finalDiffKey = diffKey;
    finalDiff = diff;
  }

  const remainderInSeconds = Math.round(
    (differenceInSeconds(dateY, dateX) / tickIntervals[finalDiffKey] -
      finalDiff) *
      tickIntervals[finalDiffKey]
  );

  const humanCountdown = arrayToSentence(humanCountdownParts, { conjunction });

  return {
    humanCountdown,
    remainderInSeconds
  };
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/CountdownTimerHuman/helpers.js